import { DEFAULT_VALUE_OPTION, instance4 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import { useState, useEffect } from "react";

const getAllMasterProdusen = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

const useInitialMasterProdusen = (
  withSearch = false,
  url = "/wmsmaster/produsen/read"
) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Produsen");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllMasterProdusen(url);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Produsen",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [withSearch, url]);

  return state;
};

export default useInitialMasterProdusen;
